import React from 'react'
import { Box } from '@usap/uicomponents'

import Actions from './Actions'
import Items from './Items'
import WarningMedium from '../../../Notification/Types/WarningMedium'

const CannotShipItems = params => {
  const { data } = params
  const { state, items, source } = data

  let message = `Sorry, we can’t ship the following item/s to <b>${state}</b>`
  if (source && source === 'paypal-OOS') {
    message = 'Sorry, one or more items in your cart are out of stock. Remove these items to proceed to checkout'
  }

  const style = {
    wrapperHeight: { min: '500px' },
    oosWrapperPad: { bottom: 'small' },
  }

  return (
    <Box pad="medium" height={style.wrapperHeight} width="700px">
      <WarningMedium message={message} />
      <Items data={items} />
      <Actions data={data} />
    </Box>
  )
}

export default CannotShipItems
